import React from 'react'
import { chooseWallpaper, conditionalWidth, imageAddress, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import Modal from '../../components/Modal';
import FormViewer from '../../components/FormViewer';
import { Doughnut, Bar, Line, Pie } from 'react-chartjs-2';
// import CollapsibleButton from '../EmailManager/collapsibelButton';
import Collapsible from "react-collapsible";
// import GlobalUserInput from '../../components/inputs/GlobalUserInput';
import SettingsViewer from '../../components/SettingsViewer';
import Confirmation from '../../components/Confirmation';
// import '../../styles/components/eagleView.scss'

class TaskRequests extends React.Component {
    constructor(props) {

        super(props)

        this.state = {




        }

    }
    componentDidMount() {

    }

    componentWillUnmount() {
    }



    render() {
        return (

            <div className="scroll-no-scrollbar h-100 modal-body py-4   " style={{ borderRadius: '0px 8px 8px 0px' }}>

                <Confirmation approveTask={this.props.approveTask} width={this.props.width} item={this.props.item} />

            </div >


        )
    }
}

export default TaskRequests;